export default __webpack_public_path__ + "static/media/Intry-Logo-Black.f9766b62.png";